/* eslint-disable import/prefer-default-export */
export const Toasts = {
  createToastRequest: 'CREATE_TOAST_REQUEST',
  createToastSuccess: 'CREATE_TOAST_SUCCESS',

  removeToastRequest: 'REMOVE_TOAST_REQUEST',
  removeToastSuccess: 'REMOVE_TOAST_SUCCESS',
};
